import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import {
  AdminApi,
  ConfigApi,
  EmployeesApi,
  PatientsApi,
  SassApi,
  TasksApi,
  TemplatesApi,
  UsersApi
} from './apis';
import rootReducers from './rootReducer';
import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  devTools: process.env.REACT_APP_ENV !== 'production',
  reducer: {
    ...rootReducers,
    [AdminApi.reducerPath]: AdminApi.reducer,
    [ConfigApi.reducerPath]: ConfigApi.reducer,
    [EmployeesApi.reducerPath]: EmployeesApi.reducer,
    [PatientsApi.reducerPath]: PatientsApi.reducer,
    [SassApi.reducerPath]: SassApi.reducer,
    [TasksApi.reducerPath]: TasksApi.reducer,
    [TemplatesApi.reducerPath]: TemplatesApi.reducer,
    [UsersApi.reducerPath]: UsersApi.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['SET-TOAST-OPTIONS'],
        ignoredActionPaths: ['payload.handleConfirm'],
        ignoredPaths: ['ToastReducer.options']
      },
      immutableCheck: false
    }).concat([
      sagaMiddleware,
      AdminApi.middleware,
      ConfigApi.middleware,
      EmployeesApi.middleware,
      PatientsApi.middleware,
      SassApi.middleware,
      TasksApi.middleware,
      TemplatesApi.middleware,
      UsersApi.middleware
    ])
});

sagaMiddleware.run(rootSaga);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
